import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FaHeartbeat } from 'react-icons/fa';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { selectHeartbeatStatus, selectHeartbeatStatusLoading } from '../store/selectors';

import SquareBox from './squareBox.component';
import RectangleBox from './rectangleBox.component';
import { renderDate } from '../../shared/dateHelpers';

const timeFormat = 'mm:ss';

class ConnectionRunStatusDashboard extends PureComponent {
  static propTypes = {
    averageRunTime: PropTypes.shape({
      averageRunDuration: PropTypes.string,
    }),
    longestRunTime: PropTypes.shape({
      runStart: PropTypes.string,
      runDuration: PropTypes.string,
    }),
    shortestRunTime: PropTypes.shape({
      runStart: PropTypes.string,
      runDuration: PropTypes.string,
    }),
    heartbeat: PropTypes.shape({
      heartbeatStatus: PropTypes.number,
      lastRunDate: PropTypes.string,
    }),
    isHeartbeatMonitorStatusLoading: PropTypes.bool.isRequired,
    heartbeatStatus: PropTypes.arrayOf(PropTypes.shape({
      heartbeatStatus: PropTypes.number.isRequired,
    })).isRequired,
  };

  render() {
    const averageRunTime = this.props.averageRunTime && this.props.averageRunTime.averageRunDuration;

    const { longestRunTime, shortestRunTime, heartbeat, heartbeatStatus } = this.props;

    const currentHeartbeatClassnames = classnames([
      'connection-run-status-dashboard-box',
      {
        'bg-success': heartbeat && heartbeatStatus[0].heartbeatStatus === 1,
        'bg-danger': !heartbeat || heartbeatStatus[0].heartbeatStatus === 0,
      },
    ]);

    return (
      <div className="connection-run-status-dashboard">
        <SquareBox
          className="connection-run-status-dashboard-box bg-info"
          header="Average Run Time"
          body={averageRunTime ? averageRunTime : '-:--'}
          footer={timeFormat}
        />
        <div className="connection-run-status-dashboard-col">
          <RectangleBox
            className="connection-run-status-dashboard-box bg-success"
            header="Longest Run Time"
            subheader={
              longestRunTime ? renderDate(longestRunTime.runStart) : null
            }
            value={longestRunTime ? longestRunTime.runDuration : null}
            subvalue={timeFormat}
          />
          <RectangleBox
            className="connection-run-status-dashboard-box bg-danger"
            header="Shortest Run Time"
            subheader={
              shortestRunTime ? renderDate(shortestRunTime.runStart) : null
            }
            value={shortestRunTime ? shortestRunTime.runDuration : null}
            subvalue={timeFormat}
          />
        </div>
        <SquareBox
          className={currentHeartbeatClassnames}
          header="Current Heartbeat"
          body={heartbeat && heartbeatStatus[0].heartbeatStatus === 1
            ? (
              <span>
                <FaHeartbeat /> Active
              </span>
            ) : (
              <span>
                <FaHeartbeat /> Inactive
              </span>
            )
          }
          footer={heartbeat && heartbeat.lastRunDate ? renderDate(heartbeat.lastRunDate) : null}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  averageRunTime: state.dashboard.connectionRunStatus.averageRunTime,
  longestRunTime: state.dashboard.connectionRunStatus.longestRunTime,
  shortestRunTime: state.dashboard.connectionRunStatus.shortestRunTime,
  heartbeat: state.dashboard.connectionRunStatus.heartbeat,
  heartbeatStatus: selectHeartbeatStatus(state),
  isHeartbeatMonitorStatusLoading: selectHeartbeatStatusLoading(state),
});

export default connect(mapStateToProps)(ConnectionRunStatusDashboard);
